import { NgModule } from '@angular/core';
import { MomentDatePipe } from './moment-date.pipe';
import { TruncatePipe } from './truncate.pipe';

const pipes = [
  MomentDatePipe, TruncatePipe
];

@NgModule({
  declarations: pipes,
  providers: [],
  exports: [...pipes],
  schemas: []
})
export class CommonPipesModule {
}
